<div class="download-report-container">
	<div class="download-report-card">
		<div class="download-report-title">Download Combined Report</div>

		<div class="download-report-actions">
			<form [formGroup]="downloadForm" class="download-form">
				<input-wrapper class="group-select-wrapper">
					<input-autocomplete
						id="selectedGroups"
						formControlName="selectedGroups"
						[label]="'Select groups'"
						[options]="milestoneGroupsName()"
						[multiple]="true"
						[isMilestoneDownloadReport]="true"
						[resetAutocomplete]="resetForm()"
					></input-autocomplete>
				</input-wrapper>
			</form>

			<div class="reporting-buttons">
				<button
					class="download-btn"
					[ngClass]="{ disabled: !downloadForm.get('selectedGroups')?.value?.length }"
					color="primary"
					mat-raised-button
					id="submit"
					(click)="downloadPdf()"
					[disabled]="!downloadForm.get('selectedGroups')?.value?.length"
				>
					<span class="dowbload-btn-content">
						<app-icon id="download-icon" [name]="'document-download'" [color]="'white'"></app-icon>
						<span class="btn-title">DOWNLOAD REPORT</span>
					</span>
				</button>
			</div>
		</div>
	</div>
</div>
